import { LandlordPersonalDetailsForm } from 'legacy-pages/pages';
import { LandlordPaymentDetailsForm } from './landlord-payment-details-form/landlord-payment-details-form';
import { LandlordVerificationDetailsForm } from './landlord-verification-details-form/landlord-verification-details-form';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import { UserIncompleteProfileAlert } from 'components/organisms/Alert/UserIncompleteProfileAlert';
import { LandlordProfileInfoStepper } from 'components/organisms/Landlord/LandlordProfileInfoStepper/LandlordProfileInfoStepper';
import LandlordPayoutDetails from './landlord-payout-details/landlord-payout-details';
import { LandlordPenalties } from './landlord-penalties/landlord-penalties';
import { usePenaltyPayments } from 'hooks/query/penalty/use-penalty-payments';

const LandlordPenaltiesWrapper = () => {
  const { data: penaltiesData, isLoading, error } = usePenaltyPayments();
  
  // Use only individual penalties for now
  const safePenalties = penaltiesData?.individualPenalties || [];
  
  return <LandlordPenalties penalties={safePenalties} />;
};

const LandlordProfileInformation = () => {
  return (
    <div className='content grow px-2 md:px-0 md:pr-11 overflow-x-auto'>
      <div className='flex justify-between items-center mb-2 lg:mb-9 px-4 md:px-[34px]'>
        <div className='title text-xl font-bold'>Profile Information</div>
      </div>
      <div className='mb-3'>
        <UserIncompleteProfileAlert />
      </div>
      <div className='flex gap-6 lg:gap-11'>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route
              path={'/'}
              element={
                <div className='flex flex-1 w-full h-[500px] shadow-white-xl'>
                  <Navigate to={'personal'} replace />
                </div>
              }
            />
            <Route path='personal' index element={<LandlordPersonalDetailsForm />} />
            <Route path='payment-details' element={<LandlordPaymentDetailsForm />} />
            <Route path='payout-details' element={<LandlordPayoutDetails />} />
            <Route path='verification' element={<LandlordVerificationDetailsForm />} />
            <Route path='penalties' element={<LandlordPenaltiesWrapper />} />
          </Routes>
        </Suspense>
        <div>
          <div className='stepper flex flex-col pl-6 lg:pl-0'>
            <LandlordProfileInfoStepper />
          </div>
        </div>
      </div>
    </div>
  );
};

export { LandlordProfileInformation };
